import { compose } from 'ramda'
import Input from 'react-toolbox/lib/input/Input'
import inputTheme from './theme.scss'
import { withTheme } from 'modules/util'

export default compose(withTheme(inputTheme))(Input)



// WEBPACK FOOTER //
// ./client/modules/ui/components/Input/index.js